'use strict';

angular.module('admin').controller('AdminUserSubscriptionOverridesController',
	['$scope', 'AdminData', 'Authentication', 'Utilities', '$stateParams', '$window',
		function($scope, AdminData, Authentication, Utilities, $stateParams, $window) {
			$scope.authentication = Authentication;
			$scope.data = {
				userId: $stateParams.userId,
				userInfo: undefined,
				availableOverrides: {
					apps: {
						name: 'Projects',
						type: 'number',
						default: 10
					},
					teamMembers: {
						name: 'Team Members',
						type: 'number',
						default: 30
					},
					mau: {
						name: 'MAU',
						type: 'number',
						default: 1000000
					},
					glossary: {
						name: 'Glossary',
						type: 'checkbox',
						default: true
					},
					xtmIntegration: {
						name: 'XTM-Integration',
						type: 'checkbox',
						default: true
					},
					appstoreIntegration: {
						name: 'Appstore-Integration',
						type: 'checkbox',
						default: true
					},
					backupsAutomatic: {
						name: 'Backups-Automatic',
						type: 'number',
						default: 10
					},
					backupsManual: {
						name: 'Backups-Manual',
						type: 'number',
						default: 10
					},
                    changelogEntries: {
					    name: 'Changelog-Entries',
                        type: 'number',
                        default: 20000
                    },
                    changelogDays: {
                        name: 'Changelog-Days',
                        type: 'number',
                        default: 180
                    },
					branching: {
						name: 'Branching',
						type: 'checkbox',
						default: true
					},
					aiPanel: {
						name: 'AI Panel',
						type: 'checkbox',
						default: true
					},
					aiScreenshotReview: {
						name: 'AI Screenshot Review',
						type: 'checkbox',
						default: true
					},
					maxBranches: {
						name: 'Maximum-Branches',
						type: 'number',
						default: 10
					},
					maxGroups: {
						name: 'Maximum-Groups',
						type: 'number',
						default: 10
					},
					automations: {
						name: 'Automations',
						type: 'checkbox',
						default: true
					},
					maxAutomations: {
						name: 'Maximum-Automations',
						type: 'number',
						default: 15
					},
					livestreams: {
						name: 'Livestreams',
						type: 'checkbox',
						default: true
					},
					translationCertificates: {
						name: 'Translation Certificates',
						type: 'checkbox',
						default: true
					}
				},
				missingOverrides: [],
				userOverrides: {},
				activeSelectAddOverride: null
			};

			$scope.processing = false;


			/**
			 * Load all the data
			 */
			$scope.init = function() {

				AdminData.userInfo({userId: $scope.data.userId}, function (userInfo) {
					console.log('userInfo');
					console.log(userInfo);
					$scope.data.userInfo = userInfo;

					$scope.data.newPlan = userInfo._planInfo.id;

					if (userInfo.planOverrides) {
						$scope.data.userOverrides = userInfo.planOverrides;
					}

					$scope.updateMissingOverrides();
				}, function (err) {
					console.log(err);
					Utilities.showMessage(
						'Problem!',
						'Problem loading user info',
						'error'
					);
				});

			};


			/**
			 * Adds a new override
			 */
			$scope.addOverride = function() {
				var key = $scope.data.activeSelectAddOverride;

				if ($scope.data.availableOverrides.hasOwnProperty(key)) {
					$scope.data.userOverrides[key] = $scope.data.availableOverrides[key].default;
					$scope.updateMissingOverrides();
				}
			};


			/**
			 * Removes a given override
			 */
			$scope.removeOverride = function(key) {
				delete $scope.data.userOverrides[key];
				$scope.updateMissingOverrides();
			};


			/**
			 * Updates the list of overrides that have not been set yet
			 */
			$scope.updateMissingOverrides = function() {
				$scope.data.missingOverrides.length = 0;

				for (var key in $scope.data.availableOverrides) {
					if (!$scope.data.userOverrides.hasOwnProperty(key)) {
						var overrideData = $scope.data.availableOverrides[key];
						$scope.data.missingOverrides.push(
							{
								key: key,
								name: overrideData.name
							}
						);
					}
				}

				if ($scope.data.missingOverrides.length) {
					$scope.data.activeSelectAddOverride = $scope.data.missingOverrides[0].key;
				}
			};


			/**
			 * Change the overrides
			 */
			$scope.changeOverride = function() {
				$scope.processing = true;

				var sendData = {
					userId: $scope.data.userId
				};

				if (Object.keys($scope.data.userOverrides).length) {
					sendData.userPlanOverrides = $scope.data.userOverrides;
				} else {
					sendData.userPlanOverrides = null;
				}

				// Send the new data to server
				AdminData.changeUserOverrides(sendData, function (returnData) {

					$scope.processing = false;

					Utilities.showMessage(
						'Success',
						'The overrides got changed',
						'success',
						function() {
							// Simply refresh the page so that all data gets newly loaded
							$window.location.reload();
						}
					);


				}, function (error) {

					var errorMessage = 'There was a problem updating the overrides!';
					if (error.data && error.data.message) {
						errorMessage = 'There was a problem: <br />' + error.data.message;
					}

					$scope.processing = false;

					Utilities.showMessage(
						'Problem!',
						errorMessage,
						'error'
					);

				});
			};


			$scope.init();
		}
	]);
